import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import clsx from "clsx";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { swal } from "sweetalert2";
import Fuse from "fuse.js";
import SearchRounded from "@material-ui/icons/SearchRounded";
import ModalVisible from "../Modal2/modal2";
import { createGroupSession } from "../../dependencies/action";
import PhoneInput from "react-phone-input-2";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {
  Avatar,
  Paper,
  Divider,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Checkbox,
  InputBase,
  Typography,
  Grid,
  Button,
  IconButton,
  ClickAwayListener,
  Tooltip,
} from "@material-ui/core";
import BasicDatePicker from "./DatePicker";
import makeStyles from "@material-ui/core/styles/makeStyles";
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import HistoryIcon from "@material-ui/icons/History";
import VideocamOutlinedIcon from "@material-ui/icons/VideocamOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axios from "axios";
import {
  MENTORSHIP_ENGAGEMENT_MEETING,
  MENTORSHIP_SCHEDULE_SESSION,
  COHORT_NAME_LIST,
  COHORT_ENGAGED_MENTORS,
  GROUP_SESSION_NAME_LIST,
  MATCH_MENTOR_LIST,
  MATCH_STARTUP_LIST,
} from "../../../../../common/constants/ApplicationUrl";
import api from "../../../../../common/dependencies/utils/Api";

import ReactSelect from "react-select";
import Link from "@material-ui/core/Link";
import * as moment from "moment";
import "@fontsource/montserrat";

const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    minHeight: "45px",
    color: "#333",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "14px",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  justforwidth: {
    width: "45%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  listContainer: {
    width: "100%",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  goalLabel: {
    marginBottom: "10px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    textAlign: "center",
    width: "100%",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0px 0px",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "1px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  checkboxRoot: {
    color: "#3AC2D7 !important",
    "&:hover": {
      backgroundColor: "none",
    },
  },
  objectFit: {
    objectFit: "contain",
  },
  spanWidth: {
    width: "90%",
  },
  searchField: {
    border: "1px solid rgba(0,0,0,0.3)",
    padding: "3px 10px 3px 50px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    borderRadius: "4px",
    margin: "10px 0",
  },
  goalLabel3: {
    marginBottom: "10px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
  },
  listOverflow: {
    width: "100%",
    height: "300px",
    overflowY: "scroll",
    [theme.breakpoints.down("md")]: {
      height: "auto",
      maxHeight: "300px",
      marginBottom: "20px",
    },
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
  wordCounter: {
    textAlign: "right",
    fontfamily: "Montserrat",
    fontSize: "14px",
    marginTop: "4px",
    color: "rgba(0,0,0,0.5)",
  },
  leftTitle: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#b499c7",
    position: "relative",
    left: "0rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
    },
  },
  leftTitle2: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#b499c7",
    position: "relative",
    left: "2rem",
    minWidth: "36vw",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0px 0px",
  },
  backButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    border: "2px solid #3ac2d7",
    transition: "0.3s",
    "&:focus": {
      color: "#3ac2d7",
      border: "2px solid #3ac2d7",
    },
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  saveButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    transition: "0.3s",
    marginLeft: "15px",
    border: "2px solid #3ac2d7",
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  offlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  onlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    opacity: 0.6,
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  commonInput: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "16px",
    color: "rgba(0,0,0,0.5)",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "5px 10px",
  },
  commonInput2: {
    fontFamily: "Montserrat",
    fontWeight: "500",
    fontSize: "16px",
    color: "rgba(0,0,0,0.87)",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "5px 10px",
  },
  goalLabel: {
    marginTop: "20px",
    marginBottom: "10px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.4)",
    [theme.breakpoints.down("md")]: {
      fontSize: "13px !important",
    },
  },
}));

const NumberSurface = (props) => {
  return (
    <>
      <Box
        style={{
          height: "34px",
          width: "34px",
          borderRadius: "50%",
          border: "2px solid #3ac2d7",
          display: "flex",
          justifyContent: "center",
          marginRight: "10px",
          fontSize: "16px",
          fontFamily: "Montserrat",
          alignItems: "center",
        }}
      >
        {props.content}
      </Box>
    </>
  );
};

const CustomModal = (props) => {
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };
  const classes = useStyles();
  const [offline, setOffline] = useState(true);
  const [offlineData, setOfflineData] = useState("");
  const [meetingLink, setMeetingLink] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hours, setHours] = useState("");
  const [goal1, setGoal1] = useState("");
  const [goal2, setGoal2] = useState("");
  const [goal3, setGoal3] = useState("");
  const [outcome, setOutcome] = useState("");
  const [title, setTitle] = useState("");
  const [directions, setDirections] = useState("");
  const [phonevalue, setPhoneValue] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("in");
  const [venue, setVenue] = useState("");
  const [address, setAddress] = useState("");
  const [phNumber, setPhNumber] = useState("");
  const [directionsError, setDirectionsError] = useState("");
  const [venueError, setVenueError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [phNumberError, setPhNumberError] = useState("");
  const [searchTooltipOpen, setSearchTooltipOpen] = useState(false);
  const [searchStartupTooltipOpen, setSearchStartupTooltipOpen] =
    useState(false);
  const [speakerList, setSpeakerList] = useState([]);
  const [speakerListId, setSpeakerListId] = useState([]);
  const [selectAllBtn,setSelectAllBtn] = useState(false);
  const [searchContent, setSearchContent] = useState();
  const [formData, setFormData] = useState(defaultFormData);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();

  const [searchList, setSearchList] = useState([]);
  const [searchStartupList, setSearchStartupList] = useState([]);
  const [searchStartupContent, setSearchStartupContent] = useState();
  const LoginData = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [copiedOpen, setCopiedOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const { modalOpen, createGroupSession, editData, fromModule } = props;

  const [error, setError] = useState();
  const [titleError, setTitleError] = useState();
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [cohortnameList, setcohortnameList] = useState([]);

  const [outcomeError, setOutcomeError] = useState();
  const [timeError, setTimeError] = useState();
  const [timeErrorBoolean, setTimeErrorBoolean] = useState(false);
  const [firstPage, showFirstPage] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [speakerArray, setSpeakerArray] = useState([]);
  const [startupsArray, setStartupsArray] = useState([]);
  const [mentorsArray, setMentorsArray] = useState([]);
  const [selectedCohortid, setSelectedCohortid] = useState();
  const [sessionformatchange, setSessionformatchange] = useState(true);

  useEffect(() => {
    // console.log("allMentorList dfsdfsdf" + props?.allMentorList);
    // console.log("allStartupList dfsdfsdf" + props?.allStartupList);
    // console.log("editdata cohort id " + editData?.cohortApplication.cohortId);
    // console.log("newCohortid edit modal " + props.newCohortid);
    // console.log("clickmodaldata edit modal " + props.clickModaldata);

    // setAllMentorList(props?.allMentorList);
    // setAllStartupList(props?.allStartupList);
    if (editData !== undefined && editData !== null) {
      api
        .POST(MATCH_MENTOR_LIST, {
          cohortId: editData?.cohortApplication.cohortId,
        })
        .then((res) => {
          // alert("test");
          setAllMentorList(res.data?.data);
        })
        .catch((err) => {});

      api
        .POST(MATCH_STARTUP_LIST, {
          cohortId: editData?.cohortApplication.cohortId,
        })
        .then((res) => {
          setAllStartupList(res.data?.data);
        })
        .catch((err) => {});
    }
    // axios({
    //   url: COHORT_ENGAGED_MENTORS,
    //   method: "post",
    //   data: {
    //     cohortId: selectedCohortid,
    //     // cohortId: "62c3cba9a299c663a19fc4ba",
    //     mentorId: "",
    //     // cohortAdminId: adminId,
    //     cohortAdminId: "",
    //     requestStatus: "Accepted",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "id",
    //       sortOrder: "ASC",
    //     },
    //     searchField: "",
    //     searchKey: "",
    //     // engStatus: "Engagged",
    //   },
    // })
    api
      .POST(COHORT_ENGAGED_MENTORS, {
        cohortId: selectedCohortid,
        // cohortId: "62c3cba9a299c663a19fc4ba",
        mentorId: "",
        // cohortAdminId: adminId,
        cohortAdminId: "",
        requestStatus: "Accepted",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "id",
          sortOrder: "ASC",
        },
        searchField: "",
        searchKey: "",
        // engStatus: "Engagged",
      })
      .then((res) => {
        // setModalPopup2(res?.data?.data);
        // setAllMentorList(res.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, [selectedCohortid]);

  const getMentorStartUpApplicationList = (cohortid) => {
    // axios({
    //   url: MATCH_MENTOR_LIST,
    //   method: "POST",
    //   data: {
    //     cohortId: cohortid,
    //   },
    // })
    api
      .POST(MATCH_MENTOR_LIST, {
        cohortId: cohortid,
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: MATCH_STARTUP_LIST,
    //   method: "POST",
    //   data: {
    //     cohortId: cohortid,
    //   },
    // })
    api
      .POST(MATCH_STARTUP_LIST, {
        cohortId: cohortid,
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (editData !== undefined && editData !== null) {
      setTitle(editData.sessionTitle);

      setDate(moment(editData.sessionDate).format("YYYY-MM-DD"));
      setTime(editData.sessionTime);
      setHours(editData.sessionDuration);
      setOfflineData(editData.sessionFormat);
      if (editData.sessionFormat === "ONLINE") {setMeetingLink(editData.vcUrl);
      setOffline(false)
    setTouched(true)}
      setOutcome(editData.desiredOutcomes);
      setGoal1(editData.sessionGoals[0]);
      setAddress(editData.address)
      setVenue(editData.venue)
      setPhoneValue(editData.phoneNo)
      setDirections(editData.directions)
      if (
        editData.sessionGoals[1] !== undefined &&
        editData.sessionGoals[1] !== ""
      ) {
        setGoal2(editData.sessionGoals[1]);
      }
      if (
        editData.sessionGoals[2] !== undefined &&
        editData.sessionGoals[2] !== ""
      ) {
        setGoal3(editData.sessionGoals[2]);
      }
      setFormData((user) => {
        return {
          ...user,
          cohortorgname: editData?.cohortApplication?.program_name,
        };
      });
      setSpeakerList(editData?.speakerUserList);
      if (
        fromModule !== undefined &&
        fromModule !== "EngagmentPage" &&
        editData !== undefined &&
        editData !== ""
      ) {
      }
      setSpeakerArray(editData?.speakerUserList.map((item) => item.id));
      setSpeakerListId(editData?.speakerUserList.map((item) => item.id));
      setMentorsArray(editData?.mentorUserList.map((item) => item.id));

      setStartupsArray(editData?.startUpUserList.map((item) => item.id));
    }
  }, [editData]);
  useEffect(() => {
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //       status: "VERIFIED",
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        status: "VERIFIED",
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if(props?.singleCohort == undefined || props?.singleCohort == null || props?.singleCohort == "")
            {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
           }
           else{
            if(item?.id == props?.singleCohort){
              let arr = {
                label: item.name,
                value: item.id,
              };
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
           }
          });
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (!searchContent) {
      setSearchTooltipOpen(false);
    } else {
      setSearchTooltipOpen(true);
    }
  }, [searchContent]);
  useEffect(() => {
    if (!searchStartupContent) {
      setSearchStartupTooltipOpen(false);
    } else {
      setSearchStartupTooltipOpen(true);
    }
  }, [searchStartupContent]);
  useEffect(() => {
    if (props?.modalData !== undefined) {
      setDate(moment(props?.modalData?.sessionDate).format("YYYY-MM-DD"));
      setHours(moment(props?.modalData?.sessionDate).format("hh:mm A"));
    }
  }, [props.modalData]);
  const getMeeting = () => {
    props.openLoader();
    // axios({
    //   url: MENTORSHIP_ENGAGEMENT_MEETING,
    //   method: "GET",
    // })
    api
      .GET(MENTORSHIP_ENGAGEMENT_MEETING)
      .then((res) => {
        setMeetingLink(res.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  const handleNext = () => {
    if (
      formData.cohortorgname !== "" &&
      formData.cohortorgname !== undefined &&
      title !== "" &&
      date !== "" &&
      hours !== "" &&
      offlineData !== "" &&
      goal1 !== "" &&
      outcome !== "" &&
      (directions !== "" ? !directionsError : true) &&
      (venue !== "" ? address !== "" ? true : false: true) &&
      (address !== "" ? venue !== "" ? true : false: true) &&
      !timeErrorBoolean
    ) {
      showFirstPage(false);
      setErrorMessage(false);
    } else {
      setErrorMessage(true);
      if(timeErrorBoolean){
        setTimeError("You cannot set a past time");
      }
    }
  };
  const handleCreateSession = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // let mentorList = props.taggingList.filter((item) => {
    //   let isThere = false;
    //   mentorsArray &&
    //   mentorsArray?.forEach((innerItem) => {
    //       if (item === innerItem.id) isThere = true;
    //     });
    //   return isThere;
    // });
    // let mentorList = props.taggingList.filter((item) => {
    //   let isThere = false;
    //   allMentorList &&
    //     allMentorList?.forEach((innerItem) => {
    //       if (item === innerItem.id) isThere = true;
    //     });
    //   return isThere;
    // });
    // console.log("mentorListSUBMIT",mentorList)
    let startupList = props.taggingList.filter((item) => {
      let isThere = false;
      allStartupList &&
        allStartupList?.forEach((innerItem) => {
          if (item === innerItem.id) isThere = true;
        });
      return isThere;
    });

    // let sampleMentor = [...mentorsArray, mentorList];
    // let sampleStartup = [...startupsArray, startupList];
    if (
      (mentorsArray?.length > 0 || startupsArray?.length > 0) &&
      speakerArray?.length > 0
    ) {
      let allGoals = [];
      allGoals.push(goal1);
      if (goal2 !== "") allGoals.push(goal2);
      if (goal3 !== "") allGoals.push(goal3);
      setErrorMessage(false);
      let params = {
        cohortAdminId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        cohortId: formData.cohortorgname.value,
        cohortApplicationId: formData.cohortorgname.value,
        speakers: speakerArray,
        mentors: mentorsArray == "" ? []:mentorsArray,
        startups: startupList,
        sessionTitle: title,
        sessionDate: date,
        sessionTime: time,
        sessionDuration: hours,
        sessionFormat: offlineData,
        vcUrl: offlineData === "OFFLINE" ? "" : meetingLink,
        sessionGoals: allGoals,
        desiredOutcomes: outcome,
        addedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        timeZone: timezone,
        venue: offlineData === "OFFLINE" ? "" :venue,
        address:offlineData === "OFFLINE" ? "" : address,
        phoneNo:offlineData === "OFFLINE" ? "" : phonevalue,
        directions:offlineData === "OFFLINE" ? "" : directions
      };
      let params2 = {
        cohortAdminId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        cohortId: editData?.cohortApplication?.cohortId,
        cohortApplicationId: editData?.cohortApplication?.id,
        speakers: speakerListId,
        mentors: mentorsArray == "" ? []:mentorsArray,
        startups: startupsArray,
        sessionTitle: title,
        sessionDate: date,
        sessionTime: time,
        sessionDuration: hours,
        sessionFormat: offlineData,
        vcUrl: offlineData === "OFFLINE" ? "" : meetingLink,
        sessionGoals: allGoals,
        desiredOutcomes: outcome,
        addedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        cohortGroupSessionId: editData?.cohortGroupSessionId,
        // cohortGroupSessionId: editData?.cohortApplication.cohortId,
        sessionStatus: editData?.sessionStatus,
        timeZone: timezone,
        venue: offlineData === "OFFLINE" ? "" :venue,
        address:offlineData === "OFFLINE" ? "" : address,
        phoneNo:offlineData === "OFFLINE" ? "" : phonevalue,
        directions:offlineData === "OFFLINE" ? "" : directions
      };

      if (editData !== undefined) {
        // console.log("params2POST",params2)
        createGroupSession(params2, "updated");
      } else {
        // console.log("paramsPOST",params)
        createGroupSession(params, "created");
      }
      // console.log("props?.parentData", props?.parentData);
      // debugger;
      setTimeout(() => {
        props.setModalOpen(false);
        showFirstPage(true);
        if (props.refreshPage !== undefined) props.refreshPage(true);
        resetValue();
        if (props?.fromPage !== undefined && props?.fromPage === "Calendar") {
          props?.parentData(true);
          props.hideModal(true);
        }
      }, 1500);
    } else {
      setErrorMessage(true);
    }
  };

  const checkboxRef = useRef([]);
  const checkboxRef2 = useRef([]);

  useEffect(() => {
    checkboxRef.current = checkboxRef.current.slice(
      0,
      allMentorList && allMentorList?.length
    );
    checkboxRef2.current = checkboxRef2.current.slice(
      0,
      allStartupList && allStartupList?.length
    );
  }, [allMentorList && allMentorList]);
  const handleClose = () => {
    props.setModalOpen(false);
    props.openEditModal(false);
    showFirstPage(true);
    resetValue();
  };
  useEffect(() => {
    if (props.EditModalValue !== undefined && props.EditModalValue) {
      setDate(moment(props?.modalData.sessionStart).format("YYYY-MM-DD"));
      setTime(moment(props?.modalData.sessionStart).format("HH:mm:ss"));
      setHours(props?.modalData.sessionDuration);
      if (props?.modalData.sessionFormat === "ONLINE") {
        setOffline(false);
      }
      setGoal1(props?.modalData.sessionGoals[0]);
      if (props?.modalData.sessionGoals[1] !== undefined)
        setGoal2(props?.modalData.sessionGoals[1]);
      if (props?.modalData.sessionGoals[2] !== undefined)
        setGoal3(props?.modalData.sessionGoals[2]);
      setOutcome(props?.modalData.desiredOutcomes);
    }
    else if(props.EditModalValue !== undefined && !props.EditModalValue) {
      resetValue();
    }
  }, [props.EditModalValue]);
  useEffect(() => {
    let arr = [];
    if (speakerList && speakerList?.length > 0) {
      speakerList.map((key, index) => {
        arr.push(key.id);
      });
      setSpeakerListId(arr);
    }
  }, [scheduleModalOpen, speakerList]);
  function isValidHttpUrl(string) {
    let url;
    
    try {
      url = new URL(string);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }
  useEffect(() => {
    if(directions === ""){
      setDirectionsError(false)
    }
  }, [directions])
  useEffect(() => {
    if(speakerArray !== ""){
      let selectedList= [];
      allMentorList?.forEach((mentorItem, mentorIndex) => {
        const found = speakerArray.find(speakerItem => mentorItem?.id == speakerItem)
        if(found == undefined){
          selectedList.push(mentorItem)
        }
      });
      if(selectAllBtn){
        props.setTaggingList([
          ...props.taggingList,
          ...(selectedList &&
            selectedList?.map((item) => item.id)),
        ]);
      }
      if(mentorsArray?.length > 0){
        setSelectAllBtn(false)
        let selectedList2= [];
        mentorsArray?.forEach((mentorItem, mentorIndex) => {
          const found = speakerArray.find(speakerItem => mentorItem == speakerItem)
          if(found == undefined){
            selectedList2.push(mentorItem)
          }
        });
      setMentorsArray(selectedList2)

      }
    }
  }, [speakerArray])

  const resetValue=()=>{
    setSelectAllBtn(false);
    setDate("");
    setTime("");
    setHours("");
    setOfflineData("");
    setMeetingLink("");
    setOutcome("");
    setGoal1("");
    setGoal2("");
    setTitle("");
    setPhoneValue("");
    setDirections("");
    setAddress("");
    setVenue("");
    setTouched(false);
    setGoal3("");
    setFormData("");
    setSpeakerList("");
    setSpeakerArray("");
    setSpeakerListId("");
    setMentorsArray("");
    props.setTaggingList([]);
    setStartupsArray("");
    setErrorMessage(false);
    setTitleError(false);
    setTimeError(false);
    setTimeErrorBoolean(false);
    setDirectionsError(false)
    setError(false);
  }
  useEffect(()=>{
    if(!props.modalOpen)
    resetValue()
  },[props.modalOpen])
  // useEffect(()=>{
  //   if(mentorsArray?.length == allMentorList?.length)
  //   setSelectAllBtn(true)
  //   else
  //   setSelectAllBtn(false)
  // },[mentorsArray])
  return (
    <>
      <ModalVisible
        modalOpen={scheduleModalOpen}
        allMentorList={allMentorList && allMentorList}
        allStartupList={allStartupList && allStartupList}
        // mentorshipId={params.mentorshipId}
        speakerArray={speakerArray}
        mentorsArray={mentorsArray}
        setMentorsArray={setMentorsArray}
        setSpeakerArray={setSpeakerArray}
        setModalOpen={setScheduleModalOpen}
        onBroadcastSelectionChange={props.onBroadcastSelectionChange}
        setTaggingList={props.setTaggingList}
        taggingList={props.taggingList}
        parentData={setSpeakerList}
      />

      <Modal
        size="lg"
        show={props.modalOpen}
        onHide={() => {
          props.setModalOpen(false);
          showFirstPage(true);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
        dialogClassName="mentorship_engagement_summary--modal_width"
        contentClassName="mentorship_engagement_summary--modal_content_width groupsessionmodal"
        style={{ borderRadius: "7px" }}
      >
        <Modal.Header
          className="d-flex"
          style={{ justifyContent: "space-between" }}
        >
          <Modal.Title className="modalHeading d-flex justify-content-center">
            COHORT GROUP SESSION
          </Modal.Title>
          <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span
              className="tooltiptext  close-window"
              style={{ left: "-130px", top: "2px", width: "130px" }}
            >
              Close Window
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          {firstPage === true ? (
            <Box style={{ padding: "35px" }}>
              <Grid container spacing={3}>
                <Grid item md={4} sm={12} className={classes.flex}>
                  <NumberSurface content="1" />
                  <Typography className={classes.leftTitle}>
                    {"SELECT COHORT*"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} md={8} sm={12}>
                  <Grid item md={8} xs={12} sm={12}>
                    <ReactSelect
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput newcohortorgnameinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      isDisabled={editData !== undefined && editData !== null}
                      onChange={(e) => {
                        setSelectedCohortid(e.value);
                        getMentorStartUpApplicationList(e.value);
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                      }}
                      options={cohortnameList}
                      placeholder={
                        formData.cohortorgname &&
                        formData.cohortorgname !== null &&
                        formData.cohortorgname !== ""
                          ? formData.cohortorgname
                          : "Cohort Name"
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item md={4} sm={12} className={classes.flex}>
                  <NumberSurface content="2" />
                  <Typography className={classes.leftTitle}>
                    {"SESSION TITLE*"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} md={8} sm={12}>
                  <Grid item xs={12} md={8} sm={12}>
                    <InputBase
                      style={{
                        border: "1px solid rgba(0,0,0,0.3)",
                        padding: "10px",
                        fontFamily: "Montserrat",
                        borderRadius: "3px",
                        fontSize: "18px",
                      }}
                      rows={1}
                      maxRows={5}
                      value={title}
                      onChange={(e) => {
                        const value = e.target.value;
                        const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                        const newerData = newData.replace(/[ ]{2,}/gi, " ");
                        if (newerData.split(" ").length <= 100) {
                          setTitle(e.target.value);
                        }
                        if (!title) {
                          setTitleError("Enter Title First");
                          return;
                        } else {
                          setError(null);
                          setTitleError(null);
                        }
                      }}
                      fullWidth
                      multiline
                      placeholder={"Enter Title"}
                    />
                    {titleError && (
                      <Typography
                        variant="caption"
                        style={{ color: "red", fontFamily: "Montserrat" }}
                      >
                        {titleError}
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} className={classes.flex}>
                  <NumberSurface content="3" />
                  <Typography className={classes.leftTitle}>
                    {"SESSION DATE & TIME*"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} md={8} sm={12}>
                  <Grid item xs={12} md={4} sm={12}>
                    <Box
                      style={{
                        border: "1px solid rgba(0,0,0,0.3)",
                        borderRadius: "4px",
                        display: "flex",
                        padding: "5px 10px",
                      }}
                    >
                      <InputBase
                        type="date"
                        // label="dd-mm-yyyy"
                        // placeholder="dd-mm-yyyy"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: new Date().toISOString().slice(0, 10),
                        }}
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "rgba(0,0,0,0.5)",
                          width: "100%",
                        }}
                        value={date}
                        onChange={(e) => {
                          setDate(e.target.value);
                          setTimeError(null);
                          setError(null);
                          let currentDate= moment().format("YYYY-MM-DD");
                          const curH = new Date().getHours();
                          const curM = new Date().getMinutes();
                          let timeTest = curH + ":" + curM;
                          if(currentDate > e.target.value){
                            setTimeError("You cannot set a past time");
                            setTimeErrorBoolean(true);
                          }
                         
                         else if(timeTest < time && currentDate == e.target.value)
                          {
                            setTimeError("");
                            setTimeErrorBoolean(false);
                          }
                         else if(timeTest > time && currentDate == e.target.value)
                          {
                            setTimeError("You cannot set a past time");
                            setTimeErrorBoolean(true);
                          }
                          else if(currentDate < e.target.value ){
                            setTimeError("");
                            setTimeErrorBoolean(false);
                          }
                          else{
                            setTimeError("");
                            setTimeErrorBoolean(true);
                        }
                          // const first = e.target.value.slice(0, 2);
                          // const second = e.target.value.slice(3);
                          // const curH = new Date().getHours();
                          // const curM = new Date().getMinutes();
                          // if (moment().format("YYYY-MM-DD") === date) {
                          //   if (parseInt(first) < parseInt(curH)) {
                          //     // setTimeError("You cannot set a past time");
                          //     // return;
                          //   }
                          //    else if (parseInt(first) === parseInt(curH)) {
                          //     if (parseInt(second) < parseInt(curM)) {
                          //       setTimeError("You cannot set a past time");
                          //       return;
                          //     }
                          //   }
                          // }
                          // else if(moment().format("YYYY-MM-DD") > date){
                          //   setTimeError("You cannot set a past time");
                          // }
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <Box
                      style={{
                        border: "1px solid rgba(0,0,0,0.3)",
                        borderRadius: "4px",
                        display: "flex",
                        padding: "5px 10px",
                      }}
                    >
                      <InputBase
                        ampm={true}
                        label="hh:mm"
                        placeholder="hh:mm"
                        type="time"
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "rgba(0,0,0,0.5)",
                          width: "100%",
                        }}
                        value={time}
                        onChange={(e) => {
                          const first = e.target.value.slice(0, 2);
                          const second = e.target.value.slice(3);
                          const curH = new Date().getHours();
                          const curM = new Date().getMinutes();
                          if (!date) {
                            setTimeError("Enter Date First");
                            return;
                          }
                          if (moment().format("YYYY-MM-DD") === date) {
                            if (parseInt(first) < parseInt(curH)) {
                              setTimeError("You cannot set a past time");
                              return;
                            } else if (parseInt(first) === parseInt(curH)) {
                              if (parseInt(second) < parseInt(curM)) {
                                setTimeError("You cannot set a past time");
                                return;
                              }
                            }
                          }
                          setTime(e.target.value);
                          setTimeErrorBoolean(false);
                          setTimeError("");
                          setError(null);
                        }}
                      />
                    </Box>
                    {timeError && (
                      <Typography
                        variant="caption"
                        style={{ color: "red", fontFamily: "Montserrat" }}
                      >
                        {timeError}
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={12} md={4} sm={12} className={classes.flex}>
                  <NumberSurface content="4" />
                  <Typography className={classes.leftTitle}>
                    {"SESSION DURATION(in hours) *"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} xs={12} md={8} sm={12}>
                  <Grid item xs={12} md={4}>
                    <ReactSelect
                      value={{
                        value: hours,
                        label: `${hours}`,
                      }}
                      className={classes.select}
                      options={[
                        { value: "0.5", label: "0.5 " },
                        { value: "1", label: "1 " },
                        { value: "1.5", label: "1.5 " },
                        { value: "2", label: "2 " },
                        { value: "2.5", label: "2.5 " },
                        { value: "3", label: "3 " },
                        { value: "3.5", label: "3.5 " },
                        { value: "4", label: "4 " },
                        { value: "4.5", label: "4.5 " },
                        { value: "5", label: "5 " },
                        { value: "5.5", label: "5.5 " },
                        { value: "6", label: "6 " },
                      ]}
                      onChange={(selected) => setHours(selected.value)}
                      styles={{
                        menu: (styles) => {
                          return {
                            ...styles,
                          };
                        },
                        option: (
                          styles,
                          { data, isDisabled, isFocused, isSelected }
                        ) => {
                          return {
                            ...styles,
                            backgroundColor: isSelected
                              ? "#b499c7"
                              : isFocused
                              ? "#e4d7ee"
                              : "white",
                            color: isSelected ? "white" : "black",
                            cursor: isDisabled ? "not-allowed" : "default",
                          };
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} md={4} sm={12} className={classes.flex}>
                  <NumberSurface content="5" />
                  <Typography className={classes.leftTitle}>
                    {"SESSION FORMAT*"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} md={8} xs={12} sm={12}>
                  {editData !== undefined && editData !== null ? (
                    <>
                      <div style={{ padding: "0.45rem" }} className="col-12">
                        {sessionformatchange === true
                          ? editData.sessionFormat
                          : ""}
                      </div>
                      <Grid item container spacing={2} md={12} xs={12} sm={12}>
                        <Grid item xs={12} md={4} sm={12}>
                          <Button
                            className={
                              offlineData === "NA"
                                ? classes.offlineButton
                                : offlineData !== "OFFLINE"
                                ? classes.offlineButton
                                : classes.onlineButton
                            }
                            variant="contained"
                            fullWidth
                            onClick={() => {
                              setSessionformatchange(false);
                              if (!date || !time || !hours) {
                                swal({
                                  title: "Info!",
                                  text: !date
                                    ? "Please select Date"
                                    : !time
                                    ? "Please select Time"
                                    : !hours
                                    ? "Please Select hours"
                                    : " Please Select all fields",
                                  icon: "info",
                                  // buttons: false,
                                });
                                return;
                              }
                              setOfflineData("ONLINE");
                              setOffline(false);
                              setError(null);
                              setTouched(true);
                              if (!meetingLink) getMeeting();
                            }}
                          >
                            MAARG PLATFORM
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={4} sm={12}>
                          <Button
                            className={
                              offlineData === "NA"
                                ? classes.offlineButton
                                : offlineData === "OFFLINE"
                                ? classes.offlineButton
                                : classes.onlineButton
                            }
                            fullWidth
                            variant="contained"
                            onClick={() => {
                              setSessionformatchange(false);

                              if (!date || !time || !hours) {
                                swal({
                                  title: "Info!",
                                  text: !date
                                    ? "Please select Date"
                                    : !time
                                    ? "Please select Time"
                                    : !hours
                                    ? "Please Select hours"
                                    : " Please Select all fields",
                                  icon: "info",
                                  // buttons: false,
                                });
                                return;
                              }
                              setOfflineData("OFFLINE");
                              setOffline(true);
                              setError(null);
                              setTouched(true);
                            }}
                          >
                            OTHER PLATFORM
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12} md={4} sm={12}>
                        <Button
                          className={
                            offlineData === "NA"
                              ? classes.offlineButton
                              : offlineData !== "OFFLINE"
                              ? classes.offlineButton
                              : classes.onlineButton
                          }
                          variant="contained"
                          fullWidth
                          onClick={() => {
                            if (!date || !time || !hours) {
                              swal({
                                title: "Info!",
                                text: !date
                                  ? "Please select Date"
                                  : !time
                                  ? "Please select Time"
                                  : !hours
                                  ? "Please Select hours"
                                  : " Please Select all fields",
                                icon: "info",
                                // buttons: false,
                              });
                              return;
                            }
                            setOfflineData("ONLINE");
                            setOffline(false);
                            setError(null);
                            setTouched(true);
                            if (!meetingLink) getMeeting();
                          }}
                        >
                          MAARG PLATFORM
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={4} sm={12}>
                        <Button
                          className={
                            offlineData === "NA"
                              ? classes.offlineButton
                              : offlineData === "OFFLINE"
                              ? classes.offlineButton
                              : classes.onlineButton
                          }
                          fullWidth
                          variant="contained"
                          onClick={() => {
                            if (!date || !time || !hours) {
                              swal({
                                title: "Info!",
                                text: !date
                                  ? "Please select Date"
                                  : !time
                                  ? "Please select Time"
                                  : !hours
                                  ? "Please Select hours"
                                  : " Please Select all fields",
                                icon: "info",
                                // buttons: false,
                              });
                              return;
                            }
                            setOfflineData("OFFLINE");
                            setOffline(true);
                            setError(null);
                            setTouched(true);
                          }}
                        >
                          OTHER PLATFORM
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>

                {!offline && (
                  <>
                    <Grid item xs={4} className={classes.flex}></Grid>
                    <Grid
                      item
                      container
                      spacing={2}
                      xs={8}
                      style={{
                        paddingTop: "0px",
                        paddingBottom: "0px",
                      }}
                    >
                      {meetingLink ? (
                        <Grid
                          item
                          xs={8}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Link
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => window.open(meetingLink, "_blank")}
                          >
                            MAARG Session Link
                          </Link>
                          <ClickAwayListener
                            onClickAway={() => setCopiedOpen(false)}
                          >
                            <div>
                              <Tooltip
                                classes={{
                                  tooltip: classes.tooltip,
                                  tooltipArrow: classes.tooltipArrow,
                                }}
                                PopperProps={{
                                  disablePortal: true,
                                }}
                                title={
                                  <Typography
                                    style={{
                                      fontFamily: "Montserrat",
                                      fontSize: "16px",
                                      color: "#fff",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Click to Copy MAARG Session Link
                                  </Typography>
                                }
                                arrow
                              >
                                <IconButton
                                  disabled={!meetingLink}
                                  onClick={() => {
                                    setShowToast(true);
                                    setTimeout(() => {
                                      setShowToast(false);
                                    }, 3000);
                                    setCopiedOpen(true);
                                    navigator.clipboard.writeText(meetingLink);
                                  }}
                                  style={{ marginLeft: "10px" }}
                                >
                                  <ContentCopyIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </ClickAwayListener>
                          {showToast && (
                            <Typography
                              variant="caption"
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                              }}
                            >
                              Copied MAARG Session Link
                            </Typography>
                          )}
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid
                      item
                      xs={8}
                      style={{
                        paddingTop: "0px",
                        paddingBottom: "0px",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "13px",
                          color: "rgba(0,0,0,0.7)",
                        }}
                      >
                        All Chats and Video Discussions may be recorded for
                        quality purposes
                      </Typography>
                    </Grid>
                  </>
                )}
                   {touched && offline && (
                  <>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={8}>
                      <InputBase
                        className={classes.commonInput}
                        placeholder={"Please Enter Details of Other Platform"}
                        fullWidth
                        onChange={(e) => {
                          setError(null);
                        }}
                      />
                    </Grid>
                  </>
                )}
                { touched  &&
                <>
                 <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="6" />
                 <Typography className={classes.leftTitle}>
                   {"VENUE"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        className={venue !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={"Please Enter the Venue of the Meeting."}
                        fullWidth
                        onChange={(e) => {
                          setVenue(e.target.value);
                        }}
                        value={venue}
                      />
                 <Grid>
                 {address !== "" && venue == "" &&(
                    <Typography
                      variant="caption"
                      style={{
                        color: "red",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}
                    >
                      Enter Venue.
                    </Typography>
                  )}
                 </Grid>
                 </Grid>
               </Grid>
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="7" />
                 <Typography className={classes.leftTitle}>
                   {"ADDRESS"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        className={address !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={"Please Enter the Address of the Meeting."}
                        fullWidth
                        onChange={(e) => {
                          setAddress(e.target.value);
                        }}
                        value={address}
                      />
                 <Grid>
                 {venue !== "" && address == "" &&(
                    <Typography
                      variant="caption"
                      style={{
                        color: "red",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}
                    >
                      Enter Address.
                    </Typography>
                  )}
                  </Grid>
                  </Grid>
               </Grid>
              
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="8" />
                 <Typography className={classes.leftTitle}>
                   {"CONTACT NUMBER"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <PhoneInput
                        country={selectedCountry}
                        countryCodeEditable={false}
                        disableDropdown	={true}
                        value={phonevalue}
                        style={{ fontSize: "15px",color:"lightgray",width:"100%",height:"100%" }}
                        onChange={(phonevalue, country) => {
                          setSelectedCountry(country.countryCode);
                          setPhoneValue(phonevalue);
                        }}
                        placeholder="Please Enter the Contact Number."
                       
                      />
                 </Grid>
               </Grid>
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="9" />
                 <Typography className={classes.leftTitle}>
                   {"DIRECTIONS LINK"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        value={directions}
                        className={venue !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={
                          "Please Enter the web link for directions to the Venue."
                        }
                        fullWidth
                        onChange={(e) => {
                          setDirections(e.target.value);
                          if(e.target.value.startsWith('https://'))
                          {
                            setDirectionsError(false)
                          }
                          else{
                            setDirectionsError(true)
                          }
                        }}
                      /> 
                           {directionsError && (
                    <Typography
                      variant="caption"
                      style={{
                        color: "red",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}
                    >
                      Please enter a proper google maps link.
                    </Typography>
                  )}
                 </Grid>
               </Grid>
               </> 
               }
             

                <Grid item xs={12} md={4} sm={12} className={classes.flex}>
                  <NumberSurface content={touched && !offline ? "10" :"6"} />
                  <Typography className={classes.leftTitle}>
                    {"SESSION GOALS (Atleast One)*"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} md={8} xs={12} sm={12}>
                  <Grid item xs={12} md={4} sm={12}>
                    <Typography className={classes.goalLabel}>
                      SET GOAL 1*
                    </Typography>
                    <InputBase
                      className={classes.commonInput}
                      placeholder={"SET GOAL 1 (max 50 words)"}
                      value={goal1}
                      rows={6}
                      multiline
                      maxRows={6}
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                        const newerData = newData.replace(/[ ]{2,}/gi, " ");
                        if (newerData.split(" ").length <= 50) {
                          setGoal1(e.target.value);
                        }
                        setError(null);
                      }}
                    />
                    <Typography className={classes.wordCounter}>
                      Word Count:{" "}
                      {goal1?.length === 0
                        ? 0
                        : goal1
                            ?.replace(/(^\s*)|(\s*$)/gi, "")
                            ?.replace(/[ ]{2,}/gi, " ")
                            ?.split(" ")?.length}
                      /50
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <Typography className={classes.goalLabel}>
                      SET GOAL 2
                    </Typography>
                    <InputBase
                      rows={6}
                      maxRows={6}
                      className={classes.commonInput}
                      placeholder={"SET GOAL 2 (max 50 words)"}
                      value={goal2}
                      multiline
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                        const newerData = newData.replace(/[ ]{2,}/gi, " ");
                        if (newerData.split(" ").length <= 50) {
                          setGoal2(e.target.value);
                        }
                        setError(null);
                      }}
                    />
                    <Typography className={classes.wordCounter}>
                      Word Count:{" "}
                      {goal2?.length === 0
                        ? 0
                        : goal2
                            ?.replace(/(^\s*)|(\s*$)/gi, "")
                            ?.replace(/[ ]{2,}/gi, " ")
                            ?.split(" ")?.length}
                      /50
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <Typography className={classes.goalLabel}>
                      SET GOAL 3
                    </Typography>
                    <InputBase
                      rows={6}
                      maxRows={6}
                      className={classes.commonInput}
                      placeholder={"SET GOAL 3 (max 50 words)"}
                      value={goal3}
                      fullWidth
                      multiline
                      onChange={(e) => {
                        const value = e.target.value;
                        const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                        const newerData = newData.replace(/[ ]{2,}/gi, " ");
                        if (newerData.split(" ").length <= 50) {
                          setGoal3(e.target.value);
                        }
                        setError(null);
                      }}
                    />
                    <Typography className={classes.wordCounter}>
                      Word Count:{" "}
                      {goal3?.length === 0
                        ? 0
                        : goal3
                            ?.replace(/(^\s*)|(\s*$)/gi, "")
                            ?.replace(/[ ]{2,}/gi, " ")
                            ?.split(" ")?.length}
                      /50
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={4} sm={12} className={classes.flex}>
                  <NumberSurface content={touched && !offline ? "11" :"7"} />
                  <Typography className={classes.leftTitle}>
                    {"DESCRIPTION/REMARKS*"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={8} sm={12}>
                  <InputBase
                    style={{
                      border: "1px solid rgba(0,0,0,0.3)",
                      padding: "10px",
                      fontFamily: "Montserrat",
                      borderRadius: "3px",
                      fontSize: "18px",
                    }}
                    rows={5}
                    maxRows={5}
                    value={outcome}
                    onChange={(e) => {
                      const value = e.target.value;
                      const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                      const newerData = newData.replace(/[ ]{2,}/gi, " ");
                      if (newerData.split(" ").length <= 100) {
                        setOutcome(e.target.value);
                      }
                      if (!outcome) {
                        setOutcomeError("Enter Description First");
                        return;
                      } else {
                        setError(null);
                        setOutcomeError(null);
                      }
                    }}
                    fullWidth
                    multiline
                    placeholder={
                      outcome === "" ? "Enter max 100 words" : outcome
                    }
                  />
                  <Typography className={classes.wordCounter}>
                    Word Count:{" "}
                    {outcome?.length === 0
                      ? 0
                      : outcome
                          ?.replace(/(^\s*)|(\s*$)/gi, "")
                          ?.replace(/[ ]{2,}/gi, " ")
                          ?.split(" ")?.length}
                    /100
                  </Typography>
                  {errorMessage && (
                    <Typography
                      variant="caption"
                      style={{
                        color: "red",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}
                    >
                      Enter All Mandatory Fields*
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4}></Grid>
                <Grid md={8} sm={12} xs={12}>
                  <Typography
                    variant="body2"
                    style={{ fontFamily: "Montserrat", color: "red" }}
                  >
                    {error}
                  </Typography>
                </Grid>
              </Grid>

              <Box
                className="cohortModal-summary"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  padding: "20px 25% 0 25% ",
                }}
              >
                <Box>
                  <Button
                    onClick={() => {
                      props.setModalOpen(false);
                      props.openEditModal(false);
                      showFirstPage(true);
                    }}
                    className={classes.backButton}
                    disableRipple
                  >
                    CLOSE
                  </Button>
                  <Button
                    onClick={() => handleNext()}
                    // onClick={handleSubmit}
                    className={clsx(classes.saveButton, "saveButton55")}
                    disableRipple
                  >
                    SAVE & NEXT
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box style={{ padding: "35px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} className={classes.flex}>
                  <NumberSurface content={touched && !offline ? "12" :"8"} />
                  <Typography className={classes.leftTitle}>
                    {"Select Speaker*"}
                  </Typography>
                </Grid>
                {speakerList &&
                speakerList?.length > 0 &&
                editData === undefined ? (
                  <Grid item xs={12} md={6} style={{ display: "inherit" }}>
                    <Typography className={classes.leftTitle2}>
                      {"Speakers Selected :"}
                      <div
                        className="d-flex flex-row"
                        style={{ flexWrap: "wrap", maxHeight: "0rem" }}
                      >
                        {speakerList.map((item, index) => (
                          <div style={{ marginLeft: "0.35rem" }}>
                            {" "}
                            {item.name}{" "}
                            {index !== speakerList?.length - 1 ? <> , </> : ""}
                          </div>
                        ))}
                      </div>
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={12} md={6} style={{ display: "inherit" }}>
                    <Typography className={classes.leftTitle2}>
                      {"Speakers Selected :"}
                      <div
                        className="d-flex flex-row"
                        style={{ flexWrap: "wrap", maxHeight: "0rem" }}
                      >
                        {speakerList &&
                          speakerList?.length > 0 &&
                          speakerList?.map((item, index) => (
                            <div style={{ marginLeft: "0.35rem" }}>
                              {" "}
                              {item.name}{" "}
                              {index !== speakerList?.length - 1 ? (
                                <> , </>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                      </div>
                    </Typography>
                  </Grid>
                )}

                <Grid item container spacing={2} xs={12}>
                  <Grid item xs={12} md={4}>
                    <Button
                      className={
                        offlineData === "NA"
                          ? classes.offlineButton
                          : offlineData !== "OFFLINE"
                          ? classes.offlineButton
                          : classes.onlineButton
                      }
                      variant="contained"
                      fullWidth
                      onClick={() => {
                        setScheduleModalOpen(true);
                      }}
                    >
                      CHOOSE SPEAKER
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={4} style={{ display: "inherit" }}>
                    <Typography
                      className={classes.goalLabel3}
                      style={{
                        marginBottom: "0px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Self
                    </Typography>
                    <Checkbox
                      classes={{
                        root: classes.checkboxRoot,
                      }}
                      checked={speakerArray.includes(LoginData.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSpeakerList((prevState) => [
                            ...prevState,
                            {
                              name: LoginData.applicant_name,
                              id: LoginData.id,
                            },
                          ]);
                          setSpeakerArray([...speakerArray, LoginData.id]);
                        } else {
                          let selectedList2= [];
                          let selectedList3= [];
                          speakerArray?.forEach((mentorItem, mentorIndex) => {
                            if(mentorItem !== LoginData.id){
                              selectedList2.push(mentorItem)
                            }
                          });
                          speakerList?.forEach((mentorItem, mentorIndex) => {
                            if(mentorItem?.id !== LoginData.id){
                              selectedList3.push(mentorItem)
                            }
                          });
                          setSpeakerArray(selectedList2)
                          setSpeakerList(selectedList3)
                          // setSpeakerList(selectedList2)
                          // setSpeakerArray(
                          //   speakerArray.filter((item) => {
                          //     return item !== LoginData.id;
                          //   })
                          // );
                          // let sample = [];
                          // sample = speakerList;
                          // sample = sample.filter(function (item) {
                          //   return item.id !== LoginData.id;
                          // });
                          // setSpeakerList(sample);
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} className={classes.flex}>
                  <NumberSurface content={touched && !offline ? "13" :"9" }/>
                  <Typography className={classes.leftTitle}>
                    {"Select Mentors and Startups to Send Invitation"}
                  </Typography>
                </Grid>
                <Grid item container spacing={2} xs={12}>
                  <Paper elevation={0} className={classes.listContainer}>
                    <Box
                      className={clsx(classes.flex, "forchanedirection")}
                      style={{ justifyContent: "space-between" }}
                    >
                      <Box
                        className={clsx(
                          classes.justforwidth,
                          "newjustforwidth"
                        )}
                      >
                        <Tooltip
                          open={searchTooltipOpen}
                          interactive
                          classes={{
                            tooltip: classes.tooltip,
                            tooltipArrow: classes.tooltipArrow,
                          }}
                          PopperProps={{
                            disablePortal: true,
                          }}
                          arrow
                          title={
                            <>
                              <ClickAwayListener
                                onClickAway={() => setSearchTooltipOpen(false)}
                              >
                                <Paper
                                  elevation={4}
                                  style={{
                                    padding: "15px",
                                    height: "300px",
                                    width: "400px",
                                    overflowY: "scroll",
                                  }}
                                >
                                  {searchList?.map((item) => (
                                    <>
                                      <ListItem alignItems="center">
                                        <ListItemSecondaryAction>
                                          <Checkbox
                                            edge="end"
                                            checked={mentorsArray.includes(
                                              item.id
                                            )}
                                            classes={{
                                              root: classes.checkboxRoot,
                                            }}
                                            onChange={(e) => {
                                              const index =
                                                allMentorList &&
                                                allMentorList?.findIndex(
                                                  (ele) => ele.id === item.id
                                                );
                                              if (index >= 0) {
                                                checkboxRef.current[
                                                  index
                                                ].click();
                                              }
                                              props.onBroadcastSelectionChange(
                                                item,
                                                e.target.checked
                                              );
                                              if (e.target.checked) {
                                                setMentorsArray([
                                                  ...mentorsArray,
                                                  item.id,
                                                ]);
                                              } else {
                                                setMentorsArray(
                                                  mentorsArray.filter(
                                                    (i) => i !== item.id
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                        </ListItemSecondaryAction>
                                        <ListItemAvatar>
                                          <Avatar
                                            classes={{
                                              img: classes.objectFit,
                                            }}
                                            src={item.image}
                                          ></Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                          primary={
                                            <>
                                              <Typography
                                                style={{
                                                  fontFamily: "Montserrat",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                {item?.name}
                                              </Typography>
                                            </>
                                          }
                                        />
                                      </ListItem>
                                      <Divider
                                        variant="inset"
                                        style={{ height: "2px" }}
                                      />
                                    </>
                                  ))}
                                </Paper>
                              </ClickAwayListener>
                            </>
                          }
                        >
                          <Box style={{ position: "relative" }}>
                            <SearchRounded
                              style={{
                                position: "absolute",
                                left: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "rgba(0,0,0,0.3)",
                              }}
                            />

                            <InputBase
                              fullWidth
                              placeholder="Search Mentors"
                              value={searchContent}
                              className={classes.searchField}
                              onChange={(e) => {
                                setSearchContent(e.target.value);
                                const fuse = new Fuse(
                                  allMentorList && allMentorList,
                                  {
                                    keys: ["name"],
                                    threshold: 0.1,
                                  }
                                );
                                const matches = fuse.search(e.target.value);
                                const results = matches.map(
                                  (item) => item.item
                                );
                                setSearchList(results);
                              }}
                            />
                          </Box>
                        </Tooltip>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "0 20px",
                          }}
                        >
                          <Typography
                            className={classes.goalLabel3}
                            style={{ flex: 1 }}
                          >
                            TOTAL MENTORS:{" "}
                            {allMentorList &&
                              allMentorList?.filter((datum) => {
                                let isThere = true;
                                speakerArray &&
                                  speakerArray?.length > 0 &&
                                  speakerArray?.forEach((i) => {
                                    if (i === datum.id) {
                                      isThere = false;
                                    }
                                  });
                                return isThere;
                              }).length}
                          </Typography>

                          <Typography className={classes.goalLabel3}>
                            Select All
                          </Typography>
                          <Checkbox
                          checked={selectAllBtn}
                            // checked={
                            //   allMentorList?.filter((datum) => {
                            //     let isThere = true;
                            //     speakerArray &&
                            //       speakerArray?.length > 0 &&
                            //       speakerArray?.forEach((i) => {
                            //         if (i === datum.id) {
                            //           isThere = false;
                            //         }
                            //       });
                            //     return isThere;
                            //   }).length === mentorsArray.length
                            //     ? true
                            //     : false
                            // }
                            classes={{
                              root: classes.checkboxRoot,
                            }}
                            onChange={(e) => {
                              // if (e.target.checked) {
                              // }
                              // else{
                              //   setSelectAllBtn(false)
                              // }
                              if (e.target.checked) {
                                setSelectAllBtn(true)
                                // allMentorList &&
                                let selectedList= [];
                                  if(speakerArray && speakerArray?.length > 0)
                                  {
                                    allMentorList?.forEach((mentorItem, mentorIndex) => {
                                      const found = speakerArray.find(speakerItem => mentorItem?.id == speakerItem)
                                      if(found == undefined){
                                        selectedList.push(mentorItem?.id)
                                      } });
                                  }
                                  else {
                                    allMentorList?.forEach((mentorItem, mentorIndex) => {
                                      // const found = speakerArray.find(speakerItem => mentorItem?.id == speakerItem)
                                      // if(found == undefined){
                                        selectedList.push(mentorItem?.id)
                                      // } });
                                  })}
                                
                                    // speakerArray?.forEach((speakerItem,speakerIndex)=>{
                                    //   console.log("speakerIndex",speakerIndex,"speakerItem",speakerItem,"mentorIndex",mentorIndex,"mentorItem",mentorItem)

                                    // })
                                    // if (!checkboxRef.current[i].checked) {
                                    //   checkboxRef.current[i].click();
                                    // }
                                 
                                  setMentorsArray(selectedList)
                                props.setTaggingList([
                                  ...props.taggingList,
                                  ...(selectedList &&
                                    selectedList?.map((item) => item.id)),
                                ]);
                                // setMentorsArray(
                                //   allMentorList &&
                                //     allMentorList?.filter((datum) => {
                                //       let isThere = true;
                                //       speakerArray &&
                                //         speakerArray?.length > 0 &&
                                //         speakerArray?.forEach((i) => {
                                //           if (i === datum.id) {
                                //             isThere = false;
                                //           }
                                //         });
                                //       return isThere;
                                //     })
                                // );
                              } else {
                                // allMentorList &&
                                //   allMentorList?.forEach((item, i) => {
                                //     if (checkboxRef.current[i].checked) {
                                //       checkboxRef.current[i].click();
                                //     }
                                //   });
                                // props.setTaggingList(
                                //   props.taggingList.filter((item) => {
                                //     let isThere = true;
                                //     allMentorList &&
                                //       allMentorList?.forEach((innerItem) => {
                                //         if (item === innerItem.id)
                                //           isThere = false;
                                //       });
                                //     return isThere;
                                //   })
                                // );
                                props.setTaggingList([])
                                setSelectAllBtn(false)
                                setMentorsArray([]);
                              }
                            }}
                          />
                        </Box>

                        <Typography
                          className={classes.goalLabel3}
                          style={{ textAlign: "right", marginRight: "40px" }}
                        >
                          Selected:{" "}{mentorsArray.length}

                          {/* {
                            allMentorList && allMentorList
                              ?.filter((datum) => {
                                let isThere = true;
                                speakerArray &&
                                  speakerArray?.length > 0 &&
                                  speakerArray?.forEach((i) => {
                                    if (i === datum.id) {
                                      isThere = false;
                                    }
                                  });
                                return isThere;
                              })
                              .filter((item) => {
                                let isThere = false;
                                mentorsArray &&
                                  mentorsArray?.length > 0 &&
                                  mentorsArray?.forEach((i) => {
                                    if (item.id === i) {
                                      isThere = true;
                                    }
                                  });
                                return isThere;
                              }).length
                          } */}
                        </Typography>
                        <Box className={classes.listOverflow}>
                          <List className={classes.list}>
                            {allMentorList &&
                              allMentorList
                                ?.filter((datum) => {
                                  let isThere = true;
                                  speakerArray &&
                                    speakerArray?.length > 0 &&
                                    speakerArray?.forEach((i) => {
                                      if (i === datum.id) {
                                        isThere = false;
                                      }
                                    });
                                  return isThere;
                                })
                                .map((datum, index) => (
                                  <>
                                    <ListItem alignItems="center">
                                      <ListItemSecondaryAction>
                                        <Checkbox
                                          edge="end"
                                          checked={
                                            mentorsArray.includes(datum.id)
                                          }
                                          inputRef={(el) =>
                                            (checkboxRef.current[index] = el)
                                          }
                                          classes={{
                                            root: classes.checkboxRoot,
                                          }}
                                          onChange={(e) => {
                                            props.onBroadcastSelectionChange(
                                              datum,
                                              e.target.checked
                                            );
                                            if (e.target.checked) {
                                              setSelectAllBtn(false)
                                              let datumarr = [datum]
                                              let selectedList= [];
                                              allMentorList?.forEach((mentorItem, mentorIndex) => {
                                                const found = datumarr.find(unSelectedItem => mentorItem?.id == unSelectedItem)
                                                if(found !== undefined){
                                                  selectedList.push(mentorItem)
                                                }
                                              });
                                              if(selectedList?.length == 0)
                                              {
                                                selectedList.push(datum)
                                              }
                                              // setMentorsArray(selectedList)
                                              setMentorsArray([
                                                ...mentorsArray,
                                                ...(selectedList &&
                                                  selectedList?.map((item) => item.id)),
                                              ]);
                                                props.setTaggingList([
                                                  ...props.taggingList,
                                                  ...(selectedList &&
                                                    selectedList?.map((item) => item.id)),
                                                ]);
                                                if(mentorsArray?.length == allMentorList?.length)
                                                {
                                                  setSelectAllBtn(true)
                                                }
                                              // setMentorsArray([
                                              //   ...mentorsArray,
                                              //   datum.id,
                                              // ]);
                                            } else {
                                              setSelectAllBtn(false)
                                              // setMentorsArray(
                                              //   mentorsArray.filter(
                                              //     (item) => item !== datum.id
                                              //   )
                                              // );
                                              let datumArr= [datum]
                                              let selectedList2= [];
                                              mentorsArray?.forEach((mentorItem, mentorIndex) => {
                                                const found = datumArr.find(unSelectedItem =>  mentorItem == unSelectedItem?.id)
                                                if(found == undefined){
                                                  selectedList2.push(mentorItem)
                                                }
                                              });
                                              setMentorsArray(selectedList2)
                                              props.setTaggingList(selectedList2)
                                              // setMentorsArray([
                                              //   ...mentorsArray,
                                              //   ...(selectedList2 &&
                                              //     selectedList2?.map((item) => item.id)),
                                              // ]);                                            
                                                // props.setTaggingList(selectedList2 &&
                                                //   selectedList2?.map((item) => item.id));
                                              // setMentorsArray([
                                              //   ...mentorsArray,
                                              //   datum.id,
                                              // ]);
                                            }
                                          }}
                                        />
                                      </ListItemSecondaryAction>
                                      <ListItemAvatar>
                                        <Avatar
                                          classes={{
                                            img: classes.objectFit,
                                          }}
                                          src={datum.image}
                                        ></Avatar>
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={
                                          <>
                                            <Typography
                                              style={{
                                                fontFamily: "Montserrat",
                                                fontSize: "16px",
                                              }}
                                            >
                                              {datum?.name}
                                            </Typography>
                                          </>
                                        }
                                      />
                                    </ListItem>
                                    <Divider variant="inset" component="li" />
                                  </>
                                ))}
                          </List>
                        </Box>
                      </Box>
                      <Box className={classes.justforwidth}>
                        <Tooltip
                          open={searchStartupTooltipOpen}
                          interactive
                          classes={{
                            tooltip: classes.tooltip,
                            tooltipArrow: classes.tooltipArrow,
                          }}
                          PopperProps={{
                            disablePortal: true,
                          }}
                          arrow
                          title={
                            <>
                              <ClickAwayListener
                                onClickAway={() =>
                                  setSearchStartupTooltipOpen(false)
                                }
                              >
                                <Paper
                                  elevation={4}
                                  style={{
                                    padding: "15px",
                                    height: "300px",
                                    width: "400px",
                                    overflowY: "scroll",
                                  }}
                                >
                                  {searchStartupList?.map((item) => (
                                    <>
                                      <ListItem alignItems="center">
                                        <ListItemSecondaryAction>
                                          <Checkbox
                                            edge="end"
                                            classes={{
                                              root: classes.checkboxRoot,
                                            }}
                                            checked={startupsArray.includes(
                                              item.id
                                            )}
                                            onChange={(e) => {
                                              const index =
                                                allStartupList &&
                                                allStartupList?.findIndex(
                                                  (ele) => ele.id === item.id
                                                );
                                              if (index >= 0) {
                                                checkboxRef2.current[
                                                  index
                                                ].click();
                                              }
                                              props.onBroadcastSelectionChange(
                                                item,
                                                e.target.checked
                                              );
                                              if (e.target.checked) {
                                                setStartupsArray([
                                                  ...startupsArray,
                                                  item.id,
                                                ]);
                                              } else {
                                                setStartupsArray(
                                                  startupsArray.filter(
                                                    (i) => i !== item.id
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                        </ListItemSecondaryAction>
                                        <ListItemAvatar>
                                          <Avatar
                                            classes={{
                                              img: classes.objectFit,
                                            }}
                                            src={item.image}
                                          ></Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                          primary={
                                            <>
                                              <Typography
                                                style={{
                                                  fontFamily: "Montserrat",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                {item?.name}
                                              </Typography>
                                            </>
                                          }
                                        />
                                      </ListItem>
                                      <Divider
                                        variant="inset"
                                        style={{ height: "2px" }}
                                      />
                                    </>
                                  ))}
                                </Paper>
                              </ClickAwayListener>
                            </>
                          }
                        >
                          <Box xs={12} style={{ position: "relative" }}>
                            <SearchRounded
                              style={{
                                position: "absolute",
                                left: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "rgba(0,0,0,0.3)",
                              }}
                            />
                            <InputBase
                              fullWidth
                              placeholder="Search Startups"
                              value={searchStartupContent}
                              className={classes.searchField}
                              onChange={(e) => {
                                setSearchStartupContent(e.target.value);
                                const fuse = new Fuse(
                                  allStartupList && allStartupList,
                                  {
                                    keys: ["name"],
                                    threshold: 0.1,
                                  }
                                );
                                const matches = fuse.search(e.target.value);
                                const results = matches.map(
                                  (item) => item.item
                                );
                                setSearchStartupList(results);
                              }}
                            />
                          </Box>
                        </Tooltip>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "0 20px",
                          }}
                        >
                          <Typography
                            className={classes.goalLabel3}
                            style={{ flex: 1 }}
                          >
                            TOTAL STARTUPS:{" "}
                            {allStartupList && allStartupList?.length}
                          </Typography>

                          <Typography className={classes.goalLabel3}>
                            Select All
                          </Typography>
                          <Checkbox
                            checked={
                              allStartupList &&
                              allStartupList?.length === startupsArray.length
                                ? true
                                : false
                            }
                            classes={{
                              root: classes.checkboxRoot,
                            }}
                            onChange={(e) => {
                              if (e.target.checked) {
                                allStartupList &&
                                  allStartupList?.forEach((item, i) => {
                                    if (!checkboxRef2.current[i].checked) {
                                      checkboxRef2.current[i].click();
                                    }
                                  });
                                props.setTaggingList([
                                  ...props.taggingList,
                                  ...(allStartupList &&
                                    allStartupList?.map((item) => item.id)),
                                ]);
                                setStartupsArray(
                                  allStartupList &&
                                    allStartupList?.map((item) => item.id)
                                );
                              } else {
                                allStartupList &&
                                  allStartupList?.forEach((item, i) => {
                                    if (checkboxRef2.current[i].checked) {
                                      checkboxRef2.current[i].click();
                                    }
                                  });
                                setStartupsArray([]);
                                props.setTaggingList(
                                  props.taggingList.filter((item) => {
                                    let isThere = true;
                                    allStartupList &&
                                      allStartupList?.forEach((innerItem) => {
                                        if (item === innerItem.id)
                                          isThere = false;
                                      });
                                    return isThere;
                                  })
                                );
                              }
                            }}
                          />
                        </Box>

                        <Typography
                          className={classes.goalLabel3}
                          style={{ textAlign: "right", marginRight: "40px" }}
                        >
                          Selected: {startupsArray.length}
                        </Typography>
                        <Box className={classes.listOverflow}>
                          <List className={classes.list}>
                            {allStartupList &&
                              allStartupList?.map((datum, index) => (
                                <>
                                  <ListItem alignItems="center">
                                    <ListItemSecondaryAction>
                                      <Checkbox
                                        edge="end"
                                        checked={startupsArray.includes(
                                          datum.id
                                        )}
                                        classes={{
                                          root: classes.checkboxRoot,
                                        }}
                                        inputRef={(el) =>
                                          (checkboxRef2.current[index] = el)
                                        }
                                        onChange={(e) => {
                                          props.onBroadcastSelectionChange(
                                            datum,
                                            e.target.checked
                                          );
                                          if (e.target.checked) {
                                            setStartupsArray([
                                              ...startupsArray,
                                              datum.id,
                                            ]);
                                          } else {
                                            setStartupsArray(
                                              startupsArray.filter(
                                                (item) => item !== datum.id
                                              )
                                            );
                                          }
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                    <ListItemAvatar>
                                      <Avatar
                                        classes={{
                                          img: classes.objectFit,
                                        }}
                                        src={datum.image}
                                      ></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Typography
                                            style={{
                                              fontFamily: "Montserrat",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {datum?.name}
                                          </Typography>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <Divider variant="inset" component="li" />
                                </>
                              ))}
                          </List>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
              {errorMessage && (
                <Typography
                  variant="caption"
                  style={{
                    color: "red",
                    fontFamily: "Montserrat",
                    fontSize: "14px",
                  }}
                >
                  Enter All Mandatory Fields*
                </Typography>
              )}
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  padding: "50px 25% 0 25% ",
                }}
              >
                <Box>
                  <Button
                    onClick={() => {
                      showFirstPage(true);
                    }}
                    className={classes.backButton}
                    disableRipple
                  >
                    BACK
                  </Button>
                  <Button
                    style={{
                      border: "2px solid #3ac2d7",
                    }}
                    onClick={() => handleCreateSession()}
                    className={clsx(classes.saveButton, "saveButton55")}
                    disableRipple
                  >
                    SUBMIT
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
  createGroupSession,
})(withRouter(CustomModal));
